const DB_NAME = 'coa-asset-cache';
const STORE_NAME = 'assets';

function openDatabase() {
    return new Promise((resolve) => {
        const request = indexedDB.open(DB_NAME, 1);
        request.onupgradeneeded = () => request.result.createObjectStore(STORE_NAME);
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => resolve(null);
    });
}

const dbPromise = typeof indexedDB !== 'undefined' ? openDatabase() : Promise.resolve(null);

export async function cacheGet(key) {
    const db = await dbPromise;

    if (!db) {
        return undefined;
    }

    return new Promise((resolve) => {
        const request = db.transaction(STORE_NAME, 'readonly').objectStore(STORE_NAME).get(key);
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => resolve(undefined);
    });
}

export async function cacheSet(key, value) {
    const db = await dbPromise;

    if (!db) {
        return;
    }

    return new Promise((resolve) => {
        const tx = db.transaction(STORE_NAME, 'readwrite');
        tx.objectStore(STORE_NAME).put(value, key);
        tx.oncomplete = () => resolve();
        tx.onerror = () => resolve();
    });
}
